enum RequestTaskStatus {
  CANCELED = 'CANCELED',
  CANCELING_FAILED = 'CANCELING_FAILED',
  CANCELING_READY = 'CANCELING_READY',
  FAILED = 'FAILED',
  PAUSE = 'PAUSE',
  PENDING = 'PENDING',
  READY = 'READY',
  SUCCESS = 'SUCCESS',
}

export default RequestTaskStatus;
